export const environment = {
    apiUrl: 'https://iplyc-dev.engesoft.com.ar',
    frontUrl: 'https://web-quinapp.iplyc-dev.engesoft.com.ar/',
    backofficeUrl: 'https://iplyc-dev.engesoft.com.ar/',
    assetsUrl: '../assets',
    awsClientUrl: 'https://checkip.amazonaws.com',
    MACRO_SECRET_KEY: "QUINAPP_157dfcc0-5563-4fa4-aa36-6fbac92d99d6",
    MACRO_COMMERCE_ID: "9c8a0331-447d-4a8f-8a13-712cefb08820",
    MACRO_URL: "https://sandboxpp.asjservicios.com.ar/",
};
